import React, { Component } from 'react';
import {connect} from 'react-redux';


import AdministrationRating from './index';

import {loadStaffByUser} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  user: state.auth.get('user'),
  staff: state.institutions.get('currentUserInstitutions')
});

const mapDispatchToProps = dispatch => ({
  loadStaff: (id, role) => dispatch(loadStaffByUser(id, role))
});

class RatingWrapper extends Component {

  componentDidMount() {
    if(!this.props.staff){
      const isManagerInstitution = this.props.user && this.props.user.get('is_staff_manager_institution')
      if(isManagerInstitution) {
        this.props.loadStaff(this.props.user.get('id'), 'is_manager_institution')
      } else {
        this.props.loadStaff(this.props.user.get('id'));
      }
    }
  }

  render() {

    if (this.props.staff === undefined) {
      return null;
    }

    return (
      <div>
        <AdministrationRating />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RatingWrapper);



// WEBPACK FOOTER //
// ./src/administration/rating/rating-wraper.js